import toast from 'react-hot-toast';
import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from '../../../../../../constants/ActionNameConstants';
import { VENDOR_PROFILE_DETAILS_API_URL } from '../../../../../../constants/ApiUrlConstants';
import { getApiRequest } from '../../../../../../features/axiosClient';
import { profileFailure, profileSuccess } from '../actions';

const getProfileAPI = (action) => getApiRequest(`${VENDOR_PROFILE_DETAILS_API_URL}?UserId=${action}`);

function* handleGetProfileAPI(action) {
  try {
    const response = yield call(getProfileAPI, action.payload);
    if (response?.data?.errorMessage !== '' && !response.data?.success) {
      toast.error(response?.data?.errorMessage);
    }
    yield put(profileSuccess(response));
  } catch (error) {
    yield put(profileFailure(error));
  }
}

export function* watchGetProfile() {
  yield takeLatest(types.GET_PROFILE_REQUEST, handleGetProfileAPI);
}
